jQuery(document).ready(function($) {

    function fadeInDirectChildren() {
        $('.fade-in-one-by-one:not(.animated), .fade-in-one-by-one-from-left .wp-block-group__inner-container:not(.animated)').each(function() {
            // console.log('i trigger');
            let delay = 350; // Delay between each child animation (milliseconds)

            let parent = $(this);
            let parentTop = parent.offset().top;
            let windowBottom = $(window).scrollTop() + $(window).height();
            let offset = 150; // Offset from the bottom (pixels)
            let shouldAnimate = (parentTop < (windowBottom - offset)); // Check if the parent is in view based on the threshold

            if (shouldAnimate) {
                let children = parent.children();
                children.each(function(index) { 
                    let child = $(this);
                    // console.log('function called');

                    setTimeout(function() {
                        child.addClass('animate-in');
                        // console.log('child', index, child);
                    }, delay * index);
                });
                parent.addClass('animated'); // Prevent re-animation on subsequent scrolls, add a parent so it does not repeat.
            }
        });

    }
    function fadeIn() {
        $('.slide-in-from-left:not(.animate-in), .slide-in-from-right:not(.animate-in), .wp-block-media-text>figure.wp-block-media-text__media:not(.animate-in), .spin-in:not(.animate-in), .slide-in-from-right-delay:not(.animate-in), .slide-in-from-up-delay:not(.animate-in), .slide-in-from-top:not(.animate-in), .slide-in-from-top-delay:not(.animate-in), .slide-in-from-up-small-delay:not(.animate-in), .slide-in-from-up:not(.animate-in), .slide-in-from-left-delay:not(.animate-in)').each(function() {
            // console.log('i trigger');
            let delay = 250; // Delay between each child animation (milliseconds)

            let parent = $(this);
            let parentTop = parent.offset().top; 
            let windowBottom = $(window).scrollTop() + $(window).height();
            let offset = 150; // Offset from the bottom (pixels)
            let shouldAnimate = (parentTop < (windowBottom - offset)); // Check if the parent is in view based on the threshold
 
            if (shouldAnimate) {
                parent.addClass('animate-in'); // Prevent re-animation on subsequent scrolls, add a parent so it does not repeat.
            }
        });

    }

    // Initial check on page load
    fadeInDirectChildren();
    fadeIn();
    // Check on scroll
    $(window).scroll(function() {
        fadeInDirectChildren();
        fadeIn();
    });

});